import { render, staticRenderFns } from "./FooterGrass.vue?vue&type=template&id=5ce9467b&"
import script from "./FooterGrass.vue?vue&type=script&lang=js&"
export * from "./FooterGrass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports